// extracted by mini-css-extract-plugin
export default {"chipContainer":"styles_chipContainer__Lvaq-","small":"styles_small__YvDdg","number":"styles_number__EE2AQ","description":"styles_description__3g4zs"};